import { getLerpedForce, generateArray } from './sketchTools';

export const noiseWaveSketch = function(p) {
  const WAVE_HEIGHT = 85;
  const FRAMERATE = 30;
  const NOISE_SPEED = 0.15;
  const NOISE_HEIGHT = 100;
  const STEP_SIZE = 95;
  const FORCE = 75;
  const LERP_MS = 2000;

  let waves = [];
  let bgColor;

  const from = p.color(75, 75, 75);
  let to = p.color(0, 0, 0);

  p.setup = function() {
    // forcing window sizes (acting weird on resize)
    p.windowWidth = window.innerWidth;
    p.windowHeight = window.innerHeight;

    p.createCanvas(p.windowWidth, p.windowHeight);
    p.frameRate(FRAMERATE);
    setupWaves();
  };

  p.draw = function() {
    p.clear();
    p.fill(bgColor);
    p.rect(0, 0, window.innerWidth, window.innerHeight);
    const force = getLerpedForce({ p: p, size: FORCE, lerp_millis: LERP_MS });
    const time = p.frameCount / FRAMERATE;
    for (let i in waves) {
      let w = waves[i];
      w.draw(force, time);
    }
  };

  const setupWaves = () => {
    waves.length = 0;
    bgColor = from;

    const count = Math.round((p.windowHeight + FORCE * 2) / WAVE_HEIGHT) + 1;
    const segments = Math.round((p.windowWidth + FORCE * 2) / STEP_SIZE) + 10;
    let step = (p.windowHeight + FORCE * 2) / count;
    let y = -FORCE;

    const toPoint = x => ({ x: x, y: y });
    const start = { x: -FORCE, y: p.windowHeight + FORCE * 2 };
    const end = { x: p.windowWidth + FORCE, y: p.windowHeight + FORCE * 2 };
    for (let i = 0; i < count; i++) {
      let clr = p.lerpColor(from, to, y / p.windowHeight);
      let points = generateArray({
        from: -FORCE,
        to: p.windowWidth + FORCE * 2,
        steps: segments
      }).map(toPoint);
      points.unshift(start);
      points.push(end);
      waves[i] = new Wave(clr, points, NOISE_HEIGHT, NOISE_SPEED);
      y += step;
    }
  };

  function Wave(color, points, noiseHeight, noiseSpeed) {
    this.color = color;
    this.points = points;
    this.noiseHeight = noiseHeight;
    this.noiseSpeed = noiseSpeed;
    return this;
  }

  Wave.prototype.draw = function(force, time) {
    p.noStroke();
    p.beginShape();
    p.fill(this.color);

    this.points.forEach(point => {
      p.vertex(
        point.x + force.x,
        point.y -
          this.noiseHeight * p.noise(point.x, point.y, time * this.noiseSpeed) +
          force.y
      );
    });

    p.endShape();
  };
};
